import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { getLanding, updateLanding } from "../../../api/landing.api";
import ErrorResponse from "../../../components/ErrorResponse";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IGetLanding } from "../../../models/landing.model";
import LandingPageEditor from "../../../components/landing/page/Editor";

interface IMatch {
  campusCode: string;
  landingCode: string;
}

const LandingEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const landingCode = Number(match.params.landingCode);
  const history = useHistory();
  const location = useLocation();

  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetLanding>();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  useEffect(() => {
    if (landingCode) {
      execute(getLanding(landingCode));
    }
  }, [landingCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/landing/page${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const submit = (data: FormData) => {
    // console.log('data', data);
    if (!landingCode) return;

    for (let key of data.entries()) {
      console.log(key);
    }
    submitExecute(updateLanding(landingCode, data));
  }

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('homepage.landing.title1')}
        currentMenu={t('homepage.landing.title2')}
      />
      <LandingPageEditor
        data={res?.data}
        submit={submit}
        mode="edit"
      />
    </div>
  );
}

export default LandingEdit;
